import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DisplayValue from '../../../utils/display-value'

import { formatEmail, formatPhone } from '../../../utils/data-formatters'
import { PREFERRED_CONTACT_OPTIONS, optionLabel } from '../../../../constants/inquiry-options'

const LeadPersonalInfo = (props) => {
    const { leadForm } = props

    return (
        <div className="event-block">
            <div className="block-type">
                <FontAwesomeIcon icon="user" /> Submitter
            </div>
            <div className="content">
                <div className="displays">
                    <DisplayValue label="Name" value={`${leadForm.firstName} ${leadForm.lastName}`} extraClass="half" showNull={true} defaultNullValue="—" />
                    <DisplayValue label="Preferred Contact" value={optionLabel(PREFERRED_CONTACT_OPTIONS, leadForm.preferredContact)} extraClass="half" showNull={true} defaultNullValue="—" />
                    <DisplayValue label="Email" value={formatEmail(leadForm.email)} extraClass="half" showNull={true} defaultNullValue="—" />
                    <DisplayValue label="Phone" value={formatPhone(leadForm.phone)} extraClass="half" showNull={true} defaultNullValue="—" />
                    <DisplayValue label="How They Found Us" value={leadForm.referralSource} extraClass="half" showNull={true} defaultNullValue="—" />
                    <DisplayValue label="Linked Account" value={leadForm.associatedUserId} extraClass="half" showNull={true} defaultNullValue="—" />
                </div>
            </div>
            <div className="actions">
                &nbsp;
            </div>
        </div>
    )
}

export default LeadPersonalInfo
